import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import lock from '../../assets/img/lock.svg';
import carbrand from '../../assets/img/carshonda.jpg';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg';
import car from '../../assets/img/car.svg';
import book from '../../assets/img/book.svg';
import barcode from '../../assets/img/barcode.svg';
import tag from '../../assets/img/tag.svg';
import Path from '../../assets/img/Path.svg';
import transmission from '../../assets/img/manual-transmission.svg';
import drivetrain from '../../assets/img/drivetrain.svg';
import cars01 from '../../assets/img/cars01.png';
import carshonda from '../../assets/img/carshonda.jpg';
import persent from '../../assets/img/persent.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import Popup from "../../Component/Popup/Popup";
import UrCarCounterBid from "../UrCardetails/UrCarCounterBid";
import Accept from "../UrCardetails/Accept";
import UrCarAction from '../UrCar/UrCarAction';
import PageNotFound from '../FallBackUI/PageNotFound';
import miles from '../../assets/img/miles.jpg';

const CarDetails = () => {
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const [carDetail, setCarDetail] = useState([]);
	const [lrgImg, setLrgImg] = useState("");
	const [distance, setDistance] = useState("");
	const [copied, setCopied] = useState(false);
	const { id } = useParams();
	const [copySuccess, setCopySuccess] = useState('');
	const [buyerDealerId, setBuyerDealerId] = useState(null);
	const [highBid, setHighBid] = useState(null);
	const [sellitNow, setSellitNow] = useState(null);
	const sellerData = useSelector(state => state.LoginReducer.payload);
	const [isOpenCounter, setIsOpenCounter] = useState(false);

	const [errors, setErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);

	const togglePopupCounter = () => {
		setIsOpenCounter(!isOpenCounter);
	}
	const [isOpenAccept, setIsOpensAccept] = useState(false);
	const togglePopupAccept = () => {
		setIsOpensAccept(!isOpenAccept);
	}
	//
	// const selectedCarDetails = useSelector(state => state.CarListReducer.payload);
	console.log("===sellerData===", sellerData)
	// console.log("===selectedCarDetails===",selectedCarDetails)

	function CarDetailList() {

		const request = {
			car_id: id,
			// buyer_dealer_id: sellerData.buyer_dealer_id,
			// "seller_dealer_id": selectedSellerId 
			seller_dealer_id: sellerData.seller_dealer_id,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,

		}
		console.log("request for car detail", request)
		API.post('carDetails/conditions', request).then(res => {
			console.log("response", res.data.data);
			console.log("Response data", res.data.data);
			if (res.data.success === true) {

			let merged = []

			for (let i = 0; i < res.data.data.length; i++) {
				merged.push({
					...res.data.data[i], ...(res.data.data1.find((item) => item.car_id === res.data.data[i].car_id))
				})
			}
			console.log("merged", merged);
			setCarDetail(merged)
			setDistance(res.data.distance);
			setLrgImg(res.data.data[0].image);
			setBuyerDealerId(res.data.data[0].buyer_dealer_id)
			setHighBid(res.data.data[0].high_bid)
			setSellitNow(res.data.data[0].max_price)
			setLoading(false);
		}
        else {
            setErrors(res.data.error)
            setErrorFlag(true)
        }
               
            }) 
            .catch(function (error) {
              if (error.response) {
                  setErrors(error.response.data.error)
                  setErrorFlag(true)
				  
				  setLoading(false);
              }
          });
	}
	const redirectpage = (pathid, seller_data) => {
		// console.log("seller_dealer_id+++++",seller_dealer_id)
		dispatch(UrCarAction.sellerid(seller_data))
		history.push("/reRunEditdetails/" + pathid);
	}
	function copytoclipboard(e) {
		document.execCommand('copy');
		e.target.focus();
		setCopySuccess('Copied!');
	};

	function img1Click(img) {
		loadLrgImg(img.target.src);
	}
	function img2Click(img) {
		console.log("values passed", img);
		console.log("Imgfile", img.target.src);
		loadLrgImg(img.target.src);
	}
	function img3Click(img) {
		loadLrgImg(img.target.src);
	}
	function img4Click(img) {
		loadLrgImg(img.target.src);
	}


	function loadLrgImg(img) {
		setLrgImg(img);
	}
	useEffect(() => {
		console.log("id value", id)
		CarDetailList();

	}, [])

	return (


		<main id="main" class="inner-page-cars rerunCarPage">
			{loading ? <Loading /> :
			
			<div id="products-details" class="products-details">
				{errorFlag === true ? <PageNotFound error={errors} /> :
					<div class="container">
						<div class="back-btn">
							<a class="back-btn-primary" onClick={() => history.push("/urcar")}><i class="bx bx-chevron-left"></i> Back</a>
						</div>
						<div class="row">

							{carDetail.length > 0 && <div class="col-md-6">

								<div class="vehicle-detail-banner banner-content clearfix">
									<div class="banner-slider">
										<div class="slider slider-for">
											<div class="slider-banner-image">
												<img src={lrgImg} alt="no image" />
											</div>


										</div>
										<div class="slider slider-nav thumb-image">
											{carDetail.length > 1 ?
												<div class="thumbnail-image">
													<div class="thumbImg">
														<img src={carDetail[1].image} alt="" onClick={img1Click} />
													</div>
												</div> : ""}
											{carDetail.length > 2 ?
												<div class="thumbnail-image">
													<div class="thumbImg">
														<img src={carDetail[2].image} alt="" onClick={img2Click} />
													</div>
												</div> : ""}
											{carDetail.length > 3 ?
												<div class="thumbnail-image">
													<div class="thumbImg">
														<img src={carDetail[3].image} alt="" onClick={img3Click} />
													</div>
												</div> : ""}
											{carDetail.length > 4 ?
												<div class="thumbnail-image">
													<div class="thumbImg">
														<img src={carDetail[4].image} alt="" onClick={img4Click} />
													</div>
												</div> : ""}


										</div>
									</div>
								</div>
							</div>}

							{carDetail.length > 0 &&
								<div class="col-md-6">
									<div class="product-dtl">
										<div class="product-info">
											<div class="product-name">{carDetail[0].year} {carDetail[0].make} {carDetail[0].model}</div>
											<p class="productdes"><label>Inventory #</label> - {carDetail[0].car_id}</p>
											<p class="productdes">{carDetail[0].car_description}</p>
											<div class="d-flex align-items-center">
												<p class="details"><img src={speedometer} alt="" /><span>{carDetail[0].mileage} {carDetail[0]?.mileage_type}</span></p>&nbsp;&nbsp;&nbsp;&nbsp;
												{carDetail[0].fuel_type == "null" || carDetail[0].fuel_type ==null || carDetail[0].fuel_type == "" || carDetail[0].fuel_type == "" || carDetail[0].fuel_type=="undefined" ||carDetail[0].fuel_type==undefined ? "" :
												<p class="details"><img src={gasolinePump} alt="" /><span>{carDetail[0].fuel_type}</span></p>}
											</div>
											<p className="details">
													<img class="miles-img" src={miles} alt="" />
													<span >Odometer</span> :
													&nbsp;{carDetail[0].odometer}
												</p>
											<p class="remaindays">{carDetail[0].days}days still to go</p>
											<p><span class="dealertaglines">Message From The Dealer - {carDetail[0].dealer_message}</span></p>
										</div>
										

										<div class="row">

											<div class="col-md-12 carpoints">
												{/* <label   className= "input-has-value">VIN Number - {carDetail[0].vin_no}</label>		   */}
												<div class="carpoint">

													<img src={car} alt="" />
													<span>{carDetail[0].vin_no}</span>
													<CopyToClipboard text={carDetail[0].engine} onCopy={() => setCopied(true)}>
														<img src={book} onClick={copytoclipboard} alt="" />
													</CopyToClipboard>

													{/* <img src={book} onClick={copytoclipboard} alt=""/>  */}
													<img src={barcode} alt="" />

												</div>
												{/* {copied ? <p>Copied !</p> : ""} */}
											</div>
										</div>

										<div class="row">
											<div class="col-md-12">
												<div class="titlestatus mt-3">
													<p><img src={book} alt="" /><span>Title status</span> - {carDetail[0].title} {carDetail[0].status}</p>
												</div>
											</div>
										</div>


										<div class="row">
											<div class="col-md-6">
												<div class="product-count">
													<h3>Buyer - {carDetail[0].dealer_type}</h3>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-12 cars-detail-ins">
												<div class="cars-detail-views">
													{/* <a class="car-btns" href="#">Sell it Now - <span class="red"> ${carDetail[0].max_price}</span></a> */}

													{/* {carDetail[0].high_bid==""|| carDetail[0].high_bid==null?
										<div class="cars-detail-views">
										<a class="car-btns" >High Bid - <span class="green"> $0</span></a>
										</div>:
									<div class="cars-detail-views">
									<a class="car-btns" >High Bid - <span class="green"> ${carDetail[0].high_bid}</span></a>
									</div>}

									
									<a class="car-btns redBtn"  onClick={togglePopupCounter}>Counter Bid</a> */}

												</div>
											</div>
											{/* <div class="col-md-12 cars-detail-ins">
	        					<div class="cars-detail-views">
									<a class="car-btns" href="#">Proxy Bid From Buyer - <span class="red">{carDetail[0].bid}$ To {carDetail[0].proxy_bid}$</span></a>
								</div>
	        				</div> */}

											<div class="col-md-12 cars-detail-ins">
												<div class="cars-buy">
													{/* <a class="cars-buy-btns greenBtn" href="#">Rerun</a> */}
													{/* <a class="cars-buy-btns greenBtn" onClick={togglePopupAccept}>Accept</a> */}
													<a class="cars-buy-btns-primary redBtn" onClick={() => { redirectpage(carDetail[0].car_id, carDetail[0]) }}>ReRun</a>
												</div>
											</div>

										</div>

									</div>


								</div>}
						</div>
					</div>}
			</div>
}

			<section id="playstoreBlock" class="playstoreBlock">
				<div class="container">


					<div class="row content">
						<div class="col-lg-12">
							<img src={appstore} />
							<img src={googleplay} />

						</div>

					</div>

				</div>
			</section>
			{isOpenCounter && <Popup
				isClose={false}
				content={<>
					<UrCarCounterBid toggle={togglePopupCounter} buyerDealerId={buyerDealerId} highBid={highBid} sellitNow={sellitNow} />
				</>}
				handleClose={togglePopupCounter}
			/>}
			{isOpenAccept && <Popup
				isClose={false}
				content={<>
					<Accept toggle={togglePopupAccept} />
				</>}
				handleClose={togglePopupAccept}
			/>}
		</main>
	)
}
export default CarDetails;